import { MD_SCREEN_MIN } from 'modules/Styleguide';

export const ENABLE_ADS_BY_ANCHOR_PAGE = true;
export const SCREEN_BREAKPOINTS = {
  SMALL_DESKTOP: 1120,
  TABLET: MD_SCREEN_MIN,
  MOBILE: 480,
};

export const ADS_PAGE_PATH = '/ads';
